import script from "./SongbirdStroke.vue?vue&type=script&setup=true&lang=js"
export * from "./SongbirdStroke.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__